import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { generalService } from 'src/app/services/general-info';
import { authService } from 'src/app/services/auth.service';
import { firstValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SelectComponent } from '../../select/select.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-reason-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SelectComponent, MatIconModule, MatTooltipModule],
  templateUrl: './reason-modal.component.html',
  styleUrls: ['./reason-modal.component.scss'],
})
export class ReasonModalComponent implements OnInit {
  lostReasons: any[] = [];
  reasonForm: FormGroup;
  hasSettingsAccess = false;

  constructor(
    private fb: FormBuilder,
    private generalService: generalService,
    private router: Router,
    private authService: authService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<ReasonModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.reasonForm = this.fb.group({
      lost_reason: ['', Validators.required],
      lost_comment: [''],
    });

    const role = this.authService.getUserRole();
    this.hasSettingsAccess = role === 'ADMIN'
  }

  ngOnInit(): void {
    this.get_data();
  }

  async get_data() {
    const response = await firstValueFrom(
      this.generalService.get({ active: true }, 'reason-lost')
    );
    this.lostReasons = response;
  }

  onSubmit(): void {
    if (this.reasonForm.valid) {
      this.dialogRef.close(this.reasonForm.value);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  goToLostReasonsSettings(): void {
    this.dialog.closeAll();  // closes this modal AND the parent lead modal
    this.router.navigate(['/settings/profile/company'], { queryParams: { tab: 'lost-reasons' } });
  }
}